import { IEnvironment } from '../models';
import { APP_VERSION } from '../version';

export const environment: IEnvironment = {
  appVersion: APP_VERSION.VERSION,
  buildNumber: APP_VERSION.BUILD_NUMBER,
  commitHash: APP_VERSION.COMMIT_HASH,
  newrelicToken: '',
  cacheDuration: 30 * 60 * 1000,
  chatbotApiUrl: 'https://immomio-ida-stage.meho.ai',
  // common properties
};
